/** @jsxImportSource @emotion/react */
import { PageHeader } from "../../../components/page-skeleton/PageHeader";
import { EditImageSelector } from "../../challenges/challenge-upsert/image-modal/EditImageSelector";
import { ChallengeImageWrapper } from "../../challenges/challenge-upsert/ChallengeImageWrapper";
import { ImagePreview } from "../../challenges/challenge-upsert/ImagePreview";
import { useFormContext } from "react-hook-form";
import { useUploadNewsImage } from "../../../service/api";
import { CardContainer } from "../../../components/page-skeleton/CardContainer";
import { CardBody } from "../../../components/page-skeleton/CardBody";
import { cardBottomPadding } from "../../../style-util";
import { ExternalLinkButton } from "../../../components/ExternalLinkButton";
import { IMAGE_GUIDE_LINK } from "../../common/hook-form/DropzoneFormField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { colors } from "../../../components/colors";
import { css } from "@emotion/react";

type Props = {
  isEdit: boolean;
};

const buttonsContainerStyle = css`
  display: flex;
  gap: 8px;
  flex-direction: row;
`;

export const NewsImageSection = ({ isEdit }: Props) => {
  const { watch, setValue } = useFormContext();
  const files = watch("files");
  const {
    mutateAsync: uploadImage,
    isLoading: imageUploadIsLoading,
  } = useUploadNewsImage();

  const fileOnChange = async (acceptedFiles: File[]) => {
    setValue("files", acceptedFiles);
  };

  return (
    <CardContainer>
      <PageHeader
        title="News image"
        subtitle="Upload the image for this news. We recommend 1000px X 1184px."
      >
        <div css={buttonsContainerStyle}>
          <ExternalLinkButton
            textColor={colors.textPrimary}
            href={IMAGE_GUIDE_LINK}
            backgroundColor={colors.transparent}
            hoverColor={colors.ctaLight}
            text="Image guide"
            icon={
              <FontAwesomeIcon icon={solid("arrow-up-right-from-square")} />
            }
          />
          {isEdit && (
            <EditImageSelector
              imageUploadIsLoading={imageUploadIsLoading}
              uploadImage={uploadImage}
              modalHeader="Edit image for this news"
            />
          )}
        </div>
      </PageHeader>
      <CardBody css={cardBottomPadding}>
        {!isEdit && (
          <ChallengeImageWrapper
            file={files && files[0]}
            onDrop={fileOnChange}
          />
        )}
        {isEdit && <ImagePreview />}
      </CardBody>
    </CardContainer>
  );
};
